import {
  useQuery,
  type UseQueryResult,
  type QueryOptions,
} from '@tanstack/react-query';
import { z } from 'zod';
import { fetcher } from '../../../../utils/api/fetcher/fetcher';
import type { ApiError } from '../../../../utils/api/ApiError/ApiError';

export const permissionsShape = z
  .object({
    manageAllUsers: z.boolean(),
    manageAllClasses: z.boolean(),
    manageAllSubscriptions: z.boolean(),
  })
  .partial();

export type Permissions = z.infer<typeof permissionsShape>;

export async function getPermissionsApi(): Promise<Permissions> {
  const permissions = await fetcher<Permissions>(
    '/user-permissions/mypermissions',
    {
      service: '/permissions',
      version: '/v2',
    }
  );

  return permissionsShape.parse(permissions);
}

export const getPermissionsApiQueryKey = () =>
  ['/v2', 'user-permissions', 'mypermissions'].filter(Boolean);

export function useGetPermissionsApi(
  customQueryOptions?: QueryOptions<Permissions, ApiError>
): UseQueryResult<Permissions, ApiError> {
  return useQuery({
    queryKey: getPermissionsApiQueryKey(),
    queryFn: () => getPermissionsApi(),
    ...customQueryOptions,
  });
}
